export const ru = {
    'minus-phrase-list': 'Минус-фразы',
    'tools-mass-actions': 'Инструменты'
};
